// Barrel — every symbol external consumers need from the cave module.
// Internal cave files should import each other directly, not through this barrel.

// domain
export {
  hasVeteranInfoConflicts,
  hasMilitaryHistoryConflicts,
} from './domain/conflictDetection';
export {
  getCaveArtifactValidationErrors,
  CAVE_VALIDATION_FIELD,
} from './domain/artifacts';
export { reconcileCaveArtifacts } from './domain/reconcileCaveArtifacts';

// hooks
export { useCaveManager } from './hooks/useCaveManager';
export { useAutoResolveArtifacts } from './hooks/useAutoResolveArtifacts';

// components
export { caveMultiFileUploader } from './components/caveMultiFileUploader';
export { createCaveUploadReview } from './components/CaveUploadReview';
export { default as ArtifactReviewPage } from './components/ArtifactReviewPage';
export {
  createVeteranInfoConflictField,
  createMilitaryHistoryConflictField,
} from './components/ConflictPageField';

// pages
export { default as caveUploadDocumentsPage } from './pages/uploadDocumentsPage';
export { default as caveRequiredDocumentsPage } from './pages/requiredDocumentsPage';
export { default as caveUploadRequiredDocumentsPage } from './pages/uploadRequiredDocumentsPage';
export { default as caveConfirmVeteranInfoPage } from './pages/confirmVeteranInfoPage';
export { default as caveConfirmMilitaryHistoryPage } from './pages/confirmMilitaryHistoryPage';
